import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'pill-country',
    templateUrl: './pill-country.component.html',
    standalone: false
})
export class PillCountryComponent {
  @Input() icon;
  @Input() type;
  @Input() disable = false;

  constructor() {}

  countryFlag(country: string): string {
    const normalizedCountry = country.toLowerCase().trim();

    if (normalizedCountry === 'global') {
      return 'regions/ww-world';
    }

    const countryCodeMap: { [key: string]: string } = {
      'canada': 'ca',
      'united-states': 'us',
      'united-kingdom': 'gb',
      'ireland': 'ie',
      'australia': 'au',
      'germany': 'de',
      'japan': 'jp',
      'china': 'cn',
      'thailand': 'th',
      'uae': 'ae',
      'mexico': 'mx',
      'hong-kong': 'hk',
      'new-zealand': 'nz',
      'malaysia': 'my',
    };

    const countryCode = countryCodeMap[normalizedCountry] || '';
    const countrySlug = normalizedCountry.replace(/\s+/g, '-');

    return `country-flags/${countryCode}-${countrySlug}`;
  }
}
